import { attachBIS } from "./swym";

/**
 * A simple wrapper to load in the SWYM provided BIS code easily on liquid templates,
 * only needs to be included once on the page
 */
export const SwymNotfiy = class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    attachBIS();
  }
};

customElements.define("swym-notify", SwymNotfiy);
